<template>
  <div class="majorStructure"  @click.stop>
    <img src="@/assets/imgs/FormATeam/component/bg.png" alt="" />
    <div class="content">
      <div class="tit">
        <img
          :src="require(`@/assets/imgs/FormATeam/component/tit${types}.png`)"
          alt=""
        />
      </div>
      <!-- 详细信息 -->
      <!-- 创建队伍 -->
      <div class="detailedInformation" v-if="types == 1">
        <p class="hint Team">
          队伍名称：<input type="text" v-model="TeamName" />
        </p>
        <div class="ConfirmExchange" style="margin-top: 15px">
          <span @click="FormTeamFun(4)"> 创建队伍 </span>
        </div>
      </div>
      <!-- 加入队伍 -->
      <div class="detailedInformation" v-if="types == 2">
        <p class="hint Team">
          入队码：<input type="text" v-model="TeamName" />
        </p>
        <div class="ConfirmExchange" style="margin-top: 15px">
          <span @click="FormTeamFun(5)"> 加入队伍 </span>
        </div>
      </div>
      <!-- 规则说明 -->
      <div class="detailedInformation" v-if="types == 3">
        <div class="rules">
          <div class="itm" style="text-align: center">
            <span>活动时间：</span
            ><span style="color: red; font-weight: 700"
              >2026年3月27日 10:00:00 ～ 2026年4月15日 23:59:59</span
            >
          </div>
          <div class="itm" style="text-align: center">活动无单独组队期，活动全程开放组队、加入队伍与积分累计功能。</div>
          <div class="itm">1.同一账号仅可创建1支队伍，或加入1支队伍，不可同时创建或加入多支队伍</div>
          <div class="itm">2.玩家可在活动页面创建队伍，生成唯一入队码，或通过好友分享入队码邀请他人加入。</div>
          <div class="itm">3.玩家可通过输入好友分享的入队码，直接加入对应队伍。</div>
          <div class="itm">4.队伍约束：</div>
          <div class="itm tindent">
           （1）玩家成功加入任意一支队伍后，全程不可主动退出队伍；
          </div>
           <div class="itm tindent">
           （2）队长全程不可踢出队伍内任意成员；
          </div>
          <div class="itm">5.单支队伍人数上限：10 人。</div>
          <div class="itm">贡献积分规则:</div>
          <div class="itm tindent">1.贡献积分换算比例：1金龙元宝 = 1 贡献积分。</div>
          <div class="itm tindent">2.贡献积分统计范围：活动期间，玩家在官网商城的所有的消费，均累计为个人积分，同时等额计入队伍总积分。</div>
          <div class="itm tindent">3.队伍总贡献积分：队伍内所有成员个人积分之和，用于解锁队伍阶梯奖励；</div>
          <div class="itm tindent">4.积分统计时间：仅统计2026 年 3 月 27 日 10:00:00 ～ 2026 年 4 月 15 日 23:59:59期间的有效消费。</div>
          <div class="itm">奖励规则</div>
          <div class="itm tindent">1.奖励解锁依据：以队伍总积分为标准，达成对应积分门槛，即可解锁对应队伍奖励，队伍奖励可叠加领取。</div>
          <div class="itm tindent">2.奖励领取资格：
            <span style="color: red; font-weight: 700">队伍的成员消费到达200积分即可领取本队伍已解锁的全部阶梯奖励。</span></div>
          <div class="itm tindent">3.队伍奖励请在活动结束前领取，逾期作废。</div>


          <!-- <div class="itm"><span>活动细则：</span></div>
          <div class="itm tindent">1.一个金龙元宝可以兑换一个同心结。</div>
          <div class="itm tindent">
            2.活动结束后，未曾使用的同心结将失效，请于活动截止前及时使用。
          </div>
          <div class="itm tindent">
            3.消耗同心结可翻开塔罗牌并获得对应奖励，活动奖励请于网站商城—个人仓库查收。
          </div>
          <div class="itm tindent">
            4.每次翻开塔罗牌获得的奖励不会重复，累计翻牌10次可获得所有全部奖励。
          </div>
          <div class="itm tindent">
            5.翻开塔罗牌所消耗的同心结会随着轮次依次递增。
          </div>
          <div class="itm tindent">
            6.本次活动奖池不会重置，同一账号仅可完整抽取一次本次活动奖励，本次活动奖池道具均为绑定。
          </div>
          <div class="itm tindent">
            7.用户获得本次活动奖池所有奖励可激活七夕隐秘商店，众多特惠道具等你来抢。
          </div>
          <div class="itm">8.翻牌消耗明细如下：</div>
          <div class="itm tindent">
            <table>
              <thead>
                <tr>
                  <th>轮数</th>
                  <th>消耗同心结</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>1</td>
                  <td>6</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>18</td>
                </tr>
                <tr>
                  <td>3</td>
                  <td>36</td>
                </tr>
                <tr>
                  <td>4</td>
                  <td>66</td>
                </tr>
                <tr>
                  <td>5</td>
                  <td>99</td>
                </tr>
                <tr>
                  <td>6</td>
                  <td>168</td>
                </tr>
                <tr>
                  <td>7</td>
                  <td>328</td>
                </tr>
                <tr>
                  <td>8</td>
                  <td>668</td>
                </tr>
                <tr>
                  <td>9</td>
                  <td>999</td>
                </tr>
                <tr>
                  <td>10</td>
                  <td>1314</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="itm">9.初始概率公示：</div>
          <div class="itm tindent">
            <table>
              <thead>
                <tr>
                  <th>初始概率</th>
                  <th>道具</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>0.05%</td>
                  <td>七夕臻爱礼包x1</td>
                </tr>
                <tr>
                  <td>0.95%</td>
                  <td>八月隐藏月替宝箱x1</td>
                </tr>
                <tr>
                  <td>2%</td>
                  <td>2025年一期新宠福袋x1</td>
                </tr>
                <tr>
                  <td>4%</td>
                  <td>33星技能卡礼包x1</td>
                </tr>
                <tr>
                  <td>8%</td>
                  <td>一大袋源土x1</td>
                </tr>
                <tr>
                  <td>9%</td>
                  <td>月卡礼包x1</td>
                </tr>
                <tr>
                  <td>11%</td>
                  <td>欧皇纯化源土礼包x1</td>
                </tr>
                <tr>
                  <td>15%</td>
                  <td>一小袋源土x1</td>
                </tr>
                <tr>
                  <td>20%</td>
                  <td>六倍经验果X10</td>
                </tr>
                <tr>
                  <td>30%</td>
                  <td>鳞叶的秘匣x1</td>
                </tr>
              </tbody>
            </table>
          </div> -->
        </div>
        <div class="ConfirmExchange" style="margin-top: 15px">
          <img
            @click="componentCancel"
            src="@/assets/imgs/FormATeam/component/cancel.png"
            alt=""
          />
        </div>
      </div>
      <!-- 温馨提示 -->
      <div class="detailedInformation" v-if="types == 4">
        <p class="hint" style="line-height: 200px">
          创建队伍后无法退出，请确定!
        </p>
        <div class="ConfirmExchange">
          <span v-if="countDownNum == 0" @click="componentConfirm('Create')">
            确定创建
          </span>
          <span
            v-else
            class="Countdown"
            :style="{
              '--countdown-num': `'${countDownNum}'`,
            }"
          >
            确定创建
          </span>
          <span @click="componentCancel"> 取消创建 </span>
        </div>
      </div>
      <!-- 温馨提示 -->
      <div class="detailedInformation" v-if="types == 5">
        <p class="hint" style="line-height: 200px">
          加入队伍后无法退出，请确定!
        </p>
        <div class="ConfirmExchange">
          <span v-if="countDownNum == 0" @click="componentConfirm('Join')">
            确定加入
          </span>
          <span
            v-else
            class="Countdown"
            :style="{
              '--countdown-num': `'${countDownNum}'`,
            }"
          >
            确定加入
          </span>
          <span @click="componentCancel"> 取消加入 </span>
        </div>
      </div>
      <!-- 隐藏兑换-->
      <div class="detailedInformation" v-if="types == 6">
        <p class="hint exchange_hint">确定使用{{}}同心结兑换吗？</p>
        <div class="ConfirmExchange">
          <img
            @click="componentCancel"
            src="@/assets/imgs/Qixi/component/cancel.png"
            alt=""
          />
          <img
            @click="componentConfirm"
            src="@/assets/imgs/Qixi/component/confirm.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    close: {
      type: Function,
      required: true, // 或根据需要设置为 false
    },
    Confirm: {
      type: Function,
      required: true,
    },
    type: { type: Number, required: true, default: 1 },
  },
  data() {
    return {
      types: "",
      TeamName: "",
      countDownNum: 5,
    };
  },
  created() {
    this.types = this.type;
  },
  mounted() {},
  methods: {
    //关闭
    componentCancel() {
      this.close();
    },
    // 确定
    componentConfirm(type) {
      this.Confirm({
        type,
        TeamName: this.TeamName,
      });
    },

    //创建队伍
    FormTeamFun(types) {
      if (this.TeamName == "") {
        return this.$message.error("请先输入名称！！！");
      }

      this.types = types;
      const tiems = setInterval(() => {
        this.countDownNum--;

        if (this.countDownNum == 0) {
          clearInterval(tiems);
        }
        console.log("11");
      }, 1000);
    },
  },
};
</script>

<style lang="less" scoped>
.majorStructure {
  position: relative;

  .content {
    width: 90%;
    position: absolute;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    // background-color: #00ff738c;

    .tit {
      width: 100%;
      text-align: center;
      // margin-bottom: 30px;
    }

    .detailedInformation {
      width: 95%;
      margin: auto;

      // 创建队伍
      .Team {
        line-height: 200px !important;

        input[type="text"] {
          color: #dba16e;
          /* 去掉所有默认边框 */
          border: none;
          /* 只保留底部边框（关键） */
          border-bottom: 1px solid #dcdfe6;
          /* 基础布局 */
          height: 30px;
          line-height: 30px;
          padding: 0 5px;
          /* 去掉默认背景和轮廓 */
          background-color: transparent;
          outline: none;
          /* 可选：调整输入框宽度 */
          width: 200px;
          font-size: 24px;
          font-weight: 700;
        }

        input[type="text"]:focus {
          border-bottom-color: #dba16e;
          /* 聚焦时变蓝色 */
        }
      }

      // start  兑换
      .hint {
        font-size: 25px;
        text-align: center;
        color: #fff;
        line-height: 40px;

        span {
          color: red;
          font-size: 25px;
          text-align: center;
        }
      }

      .ConfirmExchange {
        margin: 20px 0;
        text-align: center;

        > img {
          margin: 0 20px;
          cursor: pointer;
        }

        > span {
          padding: 10px 20px;
          background-color: #000000;
          color: #fff;
          font-weight: 800;
          font-size: 20px;
          border: 2px solid #daa16e;
          background-clip: padding-box;
          border-radius: 20px;
          cursor: pointer;
          user-select: none;
          margin: 0 10px;
          position: relative;
        }

        .Countdown::after {
          content: var(--countdown-num);
          position: absolute;
          left: 0;
          top: 0;
          border-radius: 20px;
          width: 100%;
          height: 100%;
          background-color: #000000e6;
          line-height: 45px;
        }
      }

      // end
      // start  兑换提示
      .exchange_hint {
        margin-top: 100px;
        line-height: 200px;
      }

      // end
      // start  规则说明
      // 说明
      .rules {
        padding: 20px;
        max-height: 275px;
        overflow-y: scroll;
        overflow-x: hidden;

        .itm {
          line-height: 30px;
          color: #efd498;
          font-size: 18px;

          span {
            font-size: 20px;
          }

          table {
            width: 500px;
            border-collapse: collapse;
            margin: 20px auto;
          }

          table,
          th,
          td {
            border: 1px solid #000;
          }

          th,
          td {
            text-align: center;
            padding: 8px;
          }
        }

        .tindent {
          text-indent: 1em;
        }
      }

      // end
    }
  }
}
</style>
